import { create } from 'zustand';

interface GlobalLoadingState {
  isLoading: boolean;
  loadingMessage?: string;
  setIsLoading: (isLoading: boolean) => void;
  setLoadingMessage: (message: string) => void;
}

const useGlobalLoading = create<GlobalLoadingState>((set) => ({
  isLoading: false,
  loadingMessage: 'Loading ...',
  setIsLoading: (isLoading) => set(() => ({ isLoading: isLoading })),
  setLoadingMessage: (message) => set(() => ({ loadingMessage: message })),
}));

export default useGlobalLoading;
